module.exports = __webpack_public_path__ + "img/icon_topUp.b840efd.webp";